module.exports = __webpack_public_path__ + "static/img/online.5f668106.png";